import { render, staticRenderFns } from "./BackupStorageUpdate.vue?vue&type=template&id=7bd974a1"
import script from "./BackupStorageUpdate.vue?vue&type=script&lang=js"
export * from "./BackupStorageUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports